import { jsPDF } from "jspdf";
import { formatCurrency, formatDateLong } from "../../../../../utils/textUtils";

export const generateSARPDF = (data) => {
  const isFinalized = ["Approved", "Processing", "Ongoing", "Completed"].includes(data.status);
  const approvedAmountVal = isFinalized ? (data.approvedAmount ?? data.amount) : 0;
  console.log(data)

  const doc = new jsPDF({
    orientation: "p",
    unit: "mm",
    format: "a4",
  });

  const margin = 20;
  const pageWidth = doc.internal.pageSize.getWidth();

  // Date formatting
  const today = new Date().toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  // --- 1. HEADER ---
  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.text("RBL FISHING CORPORATION", pageWidth / 2, 20, { align: "center" });

  doc.setFontSize(12);
  doc.setFont("helvetica", "normal");
  doc.text("CASH ADVANCE FORM", pageWidth / 2, 27, { align: "center" });

  // --- 2. META DATA ---
  doc.setFontSize(9);
  let metaY = 38;
  doc.text(`Time Printed: ${new Date().toLocaleTimeString()}`, margin, metaY);
  doc.text(`REFERENCE NUMBER: ${data.referenceNumber || "N/A"}`, margin, metaY + 5);

  doc.text(today, pageWidth - margin, metaY, { align: "right" });
  doc.text(`Employment Status: ${data.employmentStatus ?? '---'}`, pageWidth - margin, metaY + 5, { align: "right" });

  doc.setLineWidth(0.5);
  doc.line(margin, 50, pageWidth - margin, 50);

  // --- 3. EMPLOYEE INFORMATION GRID ---
  const gridLabelY = 58;
  const gridValueY = 63;

  doc.setFontSize(8);
  doc.setTextColor(100);
  doc.setFont("helvetica", "normal");

  doc.text("EMPLOYEE #", margin, gridLabelY);
  doc.text("EMPLOYEE NAME", margin + 45, gridLabelY);
  doc.text(`BPR`, margin + 130, gridLabelY);

  doc.setFontSize(10);
  doc.setTextColor(0);
  doc.text(String(data.employeeIdBadge || "---"), margin, gridValueY);
  doc.text(String(data.employeeFullName || "---"), margin + 45, gridValueY);
  doc.text(`Php ${formatCurrency(data.totalBasicRate) || "0.00"}`, margin + 130, gridValueY);

  const row2LabelY = 73;
  const row2ValueY = 78;
  doc.setFontSize(8);
  doc.setTextColor(100);
  doc.text("UNIT/VESSEL", margin, row2LabelY);
  doc.text("TITLE", margin + 45, row2LabelY);
  doc.text("EMPLOYEE STATUS", margin + 95, row2LabelY);
  doc.text("FORM", margin + 145, row2LabelY);

  doc.setFontSize(10);
  doc.setTextColor(0);
  doc.text(data.vesselName || "---", margin, row2ValueY);
  doc.text(data.positionName || "---", margin + 45, row2ValueY);
  doc.text(data.employeeStatus || "---", margin + 95, row2ValueY);
  doc.text(data.salaryTypeName || "---", margin + 145, row2ValueY);

  // --- 4. OVERDRAFTS TABLE ---
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text("OVERDRAFTS:", margin, 92);

  doc.setLineWidth(0.3);
  doc.line(margin, 95, pageWidth - margin, 95);

  doc.setFontSize(9);
  doc.text("LOAN DATE", margin + 5, 100);
  doc.text("LOAN AMOUNT", margin + 70, 100);
  doc.text("BALANCE TO DATE", margin + 140, 100);

  doc.line(margin, 103, pageWidth - margin, 103);

  doc.setFont("helvetica", "normal");
  doc.text(formatDateLong(data.requestedDate) || "---", margin + 5, 110);
  doc.text(formatCurrency(data.approvedAmount), margin + 70, 110);
  doc.text(formatCurrency(data.remainingLoanBalance), margin + 140, 110);

  doc.line(margin, 115, pageWidth - margin, 115);

  doc.setFont("helvetica", "bold");
  doc.text("TOTALS", margin + 5, 120);
  doc.text(`PHP ${formatCurrency(data.approvedAmount)}`, margin + 70, 120);
  doc.text(`PHP ${formatCurrency(data.remainingLoanBalance)}`, margin + 140, 120);

  // --- 5. AMOUNT & REASON ---
  const fieldX = margin;
  const inputX = margin + 50;
  let detailY = 135;

  doc.text("Amount Requested:", fieldX, detailY);
  doc.text(`PHP ${formatCurrency(data.amount)}`, inputX, detailY);
  doc.line(inputX, detailY + 1, inputX + 60, detailY + 1);

  detailY += 12;
  doc.text("Amount Approved:", fieldX, detailY);
  doc.text(`PHP ${formatCurrency(approvedAmountVal)}`, inputX, detailY);
  doc.line(inputX, detailY + 1, inputX + 60, detailY + 1);

  detailY += 12;
  doc.text("Reason For Cash Advance:", fieldX, detailY);
  doc.setFont("helvetica", "normal");
  const reasonText = data.purpose || data.reason || "---";
  const splitReason = doc.splitTextToSize(reasonText, 100);
  doc.text(splitReason, inputX, detailY);

  // --- 6. SIGNATURE SECTION ---
  const sigStartY = 185;
  const colWidth = 75;
  const col2X = margin + 95;

  function sigY(rowIndex) {
    return sigStartY + (rowIndex * 30);
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);

  // Row 1: Requested by / Recommended by
  doc.line(margin, sigY(0), margin + colWidth, sigY(0));
  doc.text("Requested by:", margin, sigY(0) + 5);
  doc.setFont("helvetica", "normal");
  doc.text(data.employeeFullName || "", margin, sigY(0) - 2);

  doc.setFont("helvetica", "bold");
  doc.line(col2X, sigY(0), col2X + colWidth, sigY(0));
  doc.text("Recommended by:", col2X, sigY(0) + 5);

  const recommendedByApprovals = (data.hierarchyTrail || []).filter(a => a.hierarchy === 1 && a.status === "Approved");
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  recommendedByApprovals.forEach((app, index) => {
    const yOffset = sigY(0) - 2 - (index * 4);
    doc.text(app.approverFullName.toUpperCase(), col2X, yOffset);
    if (app.actionDate) {
      const actionDate = new Date(app.actionDate).toLocaleDateString();
      doc.setFontSize(6);
      doc.text(`(${actionDate})`, col2X + 50, yOffset);
      doc.setFontSize(8);
    }
  });

  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);

  // Row 2 Left: Noted by (REPLACED: Moved from Row 3 to Row 2 Left)
  doc.line(margin, sigY(1), margin + colWidth, sigY(1));
  doc.text("Noted by:", margin, sigY(1) + 5);

  const notedByApprovals = (data.hierarchyTrail || []).filter(a => a.hierarchy === 2 && a.status === "Approved");
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  notedByApprovals.forEach((app, index) => {
    const yOffset = sigY(1) - 2 - (index * 4);
    doc.text(app.approverFullName.toUpperCase(), margin, yOffset);
    if (app.actionDate) {
      const actionDate = new Date(app.actionDate).toLocaleDateString();
      doc.setFontSize(6);
      doc.text(`(${actionDate})`, margin + 50, yOffset);
      doc.setFontSize(8);
    }
  });

  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);

  // Row 2 Right: Approved by (Remains at Row 2 Right)
  doc.line(col2X, sigY(1), col2X + colWidth, sigY(1));
  doc.text("Approved by:", col2X, sigY(1) + 5);

  const successfulApprovals = (data.amountTrail || []).filter(a => a.status === "Approved");
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  successfulApprovals.forEach((app, index) => {
    const yOffset = sigY(1) - 2 - (index * 4);
    doc.text(app.approverFullName.toUpperCase(), col2X, yOffset);

    if (app.actionDate) {
      const actionDate = new Date(app.actionDate).toLocaleDateString();
      doc.setFontSize(6);
      doc.text(`(${actionDate})`, col2X + 50, yOffset);
      doc.setFontSize(8);
    }
  });

  // Row 3: Prepared by (REPLACED: Moved from Row 2 to Row 3 Left)
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.line(margin, sigY(2), margin + colWidth, sigY(2));
  doc.text("Prepared by:", margin, sigY(2) + 5);
  doc.setFont("helvetica", "normal");
  doc.text(data.preparedBy || "", margin, sigY(2) - 2);

  // --- SAVE ---
  doc.save(`${data.referenceNumber || "Form"}.pdf`);
};